import * as Types from '../../../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type ProductCreateSwapMutationVariables = Types.Exact<{
  nextSubSku: Types.Scalars['String'];
  orderId: Types.Scalars['Int'];
}>;


export type ProductCreateSwapMutation = { __typename?: 'mutation_root', result: { __typename?: 'OrderSwapCreateSwap', orderId: number } };


export const ProductCreateSwapDocument = gql`
    mutation productCreateSwap($nextSubSku: String!, $orderId: Int!) {
  result: nest_orderSwap_createSwap(sku: $nextSubSku, orderId: $orderId) {
    orderId
  }
}
    `;
export function useProductCreateSwapMutation(baseOptions?: Apollo.MutationHookOptions<ProductCreateSwapMutation, ProductCreateSwapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductCreateSwapMutation, ProductCreateSwapMutationVariables>(ProductCreateSwapDocument, options);
      }
export type ProductCreateSwapMutationHookResult = ReturnType<typeof useProductCreateSwapMutation>;
export type ProductCreateSwapMutationResult = Apollo.MutationResult<ProductCreateSwapMutation>;
export type ProductCreateSwapMutationOptions = Apollo.BaseMutationOptions<ProductCreateSwapMutation, ProductCreateSwapMutationVariables>;